import { render, staticRenderFns } from "./DefaultEndingPage.vue?vue&type=template&id=2b2ab526&scoped=true"
import script from "./DefaultEndingPage.vue?vue&type=script&lang=ts"
export * from "./DefaultEndingPage.vue?vue&type=script&lang=ts"
import style0 from "./DefaultEndingPage.vue?vue&type=style&index=0&id=2b2ab526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2ab526",
  null
  
)

export default component.exports